

import FamilyImage from "../../images/hugging.jpg";
import NetworkingImage from "../../images/networking.jpg";
import CelebrateImage from "../../images/celebrate.jpeg";

export const AboutPacs = [
    {
        image: FamilyImage,
        title: "We're more than a community, we're a family!",
        text: <span>PACTS is a passion project created by analytical chemists for analytical chemists.
            <br/><br/>At PACTS,
            we believe real, impactful, moments happen when community meets creativity. We hope everyone leaves
            feeling inspired, and excited to create the next great breakthrough!</span>

    },
    {
        image: NetworkingImage,
        title: "Network with experts and peers",
        text: <span>Join us during breaks and lunch to connect with peers, speakers,
            and industry experts. <br/><br/>
            These networking opportunities are perfect for sharing ideas and
            building valuable professional relationships.</span>
    },
    {
        image: CelebrateImage,
        title: "Enjoy good eats and gorgeous views",
        text: <span>
                Throughout the day, enjoy complimentary food and beverages in a stunning San Diego setting.
            </span>
    }
]